import { render, staticRenderFns } from "./order_cc.vue?vue&type=template&id=3495b1ee&scoped=true&"
import script from "./order_cc.vue?vue&type=script&lang=js&"
export * from "./order_cc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495b1ee",
  null
  
)

export default component.exports